// Coffeescript transformed to Javascript via https://awsm-tools.com/code/coffee2js
// See: http://getcontenttools.com/tutorials/adding-new-tools
import ContentTools from 'ContentTools/build/content-tools.min.js';
import { coffeeExtends } from './helpers';

export const initEventTool = function () {
    (function (_super) {
        coffeeExtends(EventTool, _super);
        function EventTool() {
            return EventTool.__super__.constructor.apply(this, arguments);
        }
        ContentTools.ToolShelf.stow(EventTool, 'event');
        EventTool.label = 'Insert Event';
        EventTool.icon = 'event';
        EventTool.tagName = 'ev';
        EventTool.apply = (element, selection, callback) => {
            const cursor = selection.get()[0] + 1;
            const tip = element.content.substring(0, selection.get()[0]);
            const tail = element.content.substring(selection.get()[1]);
            const evHtml = `<${EventTool.tagName} contenteditable="false">EVENT NAME</${EventTool.tagName}>`;
            // http://getcontenttools.com/api/html-string
            element.content = tip.concat(
                new window.HTMLString.String(' ', true),
                evHtml,
                new window.HTMLString.String(' ', true),
                tail,
                false
            );
            element.updateInnerHTML();
            element.taint();

            // Restore the selection
            selection.set(cursor, cursor);
            element.selection(selection);
            ContentTools.Tools.LineBreak.dispatchEditorEvent('tool-applied', {
                name: 'CKP_EventTool',
                transform: true
            });
            callback(true);
        };
        return EventTool;
    })(ContentTools.Tools.LineBreak);
};
